module.exports = __webpack_public_path__ + "img/amp-guitar.b6a67ea5.svg";